<template>
  <div class="box">
    <div class="box-top">
      <div class="left">
        <p style="margin-right: 16px">进出类型：</p>
        <div @click="doFilter1()" :class="{'active': search.flag===''}">全部</div>
        <div @click="doFilter1(0)" :class="{'active': search.flag===0}">注册车辆</div>
        <div @click="doFilter1(1)" :class="{'active': search.flag===1}">临时车辆</div>
      </div>
      <div class="right">
        <div>
          <span>牌号 </span><el-input size="small" v-model="search.carNumber" placeholder="请输入车牌号" clearable style="width: 200px"></el-input>
        </div>
        <div style="margin: 0 10px">
          <span>日期 </span><el-date-picker size="small" @change="doFilter" v-model="search.time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </div>
        <span class="button" @click="doFilter">查询</span>
      </div>
    </div>
     <el-table
        stripe
        :data="listData"
        height="69vh"
        style="width: 100%;"
       >
        <template slot="empty">
          <p>{{dataText}}</p>
        </template>
        <el-table-column label="序号" width="100" center>
          <template slot-scope="scope">
            <a style="padding-left:1vw;">{{ scope.row.index}}</a>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="车牌号">
          <template slot-scope="scope"  >
            <span>{{ scope.row.carNumber }}</span>
            <el-image 
              style="width: 100px; height: 100px;display:none"
              :src="scope.row.photo" 
              :preview-src-list="scope.row.srcList">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
         <el-table-column label="最后进出照片">
          <template slot-scope="scope">
            <img style="width: 100%" :src="scope.row.enterPhoto">
          </template>
        </el-table-column>
        <el-table-column label="出入次">
          <template slot-scope="scope">
            <span>{{scope.row.inOutCount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="时长">
          <template slot-scope="scope">
            <span>{{scope.row.parkingTime}}/h</span>
          </template>
        </el-table-column>
        <el-table-column label="最近一次进时间">
          <template slot-scope="scope">
            <span>{{scope.row.enterDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="最近一次出时间">
          <template slot-scope="scope">
            <span>{{scope.row.outDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="color1 hand" @click="lookPhoto(scope.row)" style="cursor: pointer">查看</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[3, 5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
        ></el-pagination>
      <el-dialog
          title="车辆图片"
          :visible.sync="dialogVisible"
          width="70%"
          :before-close="handleClose">
        <img style="width:100%" :src="itemPhoto">
      </el-dialog>
  </div>
</template>

<script>
  import base from '../../../../untils/base'
  import myHttp from '../../../../untils/port'
  import util from '../../../../untils/util'
  export default {
    data() {
      return {
        search: {
          //查询
          carNumber: '',
          projectId: '',
          flag:'',
          time: '',
        },
        listData: [], //表格数据
        dataText: '数据加载中...',
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        dialogVisible:false,
        itemPhoto:''
      }
    },
    created() {
      if (util.session.get('roleId') == '4') {
        this.search.projectId = util.session.get('groupId')
      } else {
        this.search.projectId = util.session.get('proId')
      }
    },
    mounted() {
      if (util.session.get('roleId') == '4') {
        this.search.projectId = util.session.get('groupId')
      } else {
        this.search.projectId = util.session.get('proId')
      }
      this.getDict() //获取考勤
    },
    methods: {
      //
      getDict() {
        var that = this
        myHttp
          .getDictByType({
            type: 'attend_type',
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.attendType = resp.data.data.dictList
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      //获取类型
      filterSatus(str) {
        var list = this.attendType
        var result = ''
        for (var i = 0; i < list.length; i++) {
          if (str == list[i].value) {
            result = list[i].label
          }
        }
        return result
      },
      // 搜索数据
      doFilter() {
        this.currentPage = 1
        this.getData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      //监控当前页码
      currentChangePage(list) {
        this.getData()
      },
      // 获取数据
      getData() {
        var that = this
        this.search.pageNum = this.currentPage
        this.search.pageSize = this.pageSize
        myHttp.selectCarInOutInfoPage(this.search).then(
          function (resp) {
            console.log(resp);
            if (resp.data.code == '200') {
              var list = resp.data.data.pageInfo.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                list[i].typeName = that.filterSatus(list[i].status)
                list[i].enterPhoto=list[i].enterPhoto && list[i].enterPhoto != ''
                    ? base.httpCtx + list[i].enterPhoto
                    : ''
                list[i]. srcList=list[i].enterPhoto && list[i].enterPhoto != ''
                    ? [list[i].enterPhoto]
                    : ''
                list[i].outPhoto=list[i].outPhoto && list[i].outPhoto != ''
                    ? base.httpCtx + list[i].outPhoto
                    : ''
              console.log(list[i].enterPhoto)
              }
              that.listData = list
              that.totalItems = resp.data.data.pageInfo.total || 0
              if (that.listData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function () {}
        )
      },
      exportWorker() {
        var token = util.session.get('token')
        window.open(
          myHttp.exportAttendList +
            '?projectId=' +
            this.search.projectId +
            '&personName=' +
            this.search.personName +
            '&date=' +
            this.search.date +
            '&accessToken=' +
            token
        )
      },
      personInfo(index, row) {
        this.$router.push({ name: 'workerInfo', params: { id: row.personId } })
      },
      doFilter1(index){
      console.log(index)
      if(index==undefined){
        this.search.flag=''
        this.getData()
      }else{
        this.search.flag=index
        this.getData()
      }

      },
      lookPhoto(row){
        console.log(row)
          this.dialogVisible =true
          this.itemPhoto =row.enterPhoto
      },
      lookPhotoout(row){
        this.dialogVisible =true
          this.itemPhoto =row.outPhoto
      },
      handleClose(){
        this.dialogVisible =false
      }
    },
  }
</script>

<style scoped>
.button{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.box{
  margin-top: 8px;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.box-top{
  height: 56px;
  padding: 15px 18px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #D8D8D8;
}
.left{
  display: flex;
}
.left > p, div {
  font-size: 16px;
  color: #666;
}
.left > div{
  margin-right: 32px;
  cursor: pointer;
  padding-bottom: 38px;
}
.right{
  display: flex;
}
.active{
  border-bottom: 2px solid #0D3A95;
}
</style>